import { createSelector } from "reselect";

import { selectSelectedEntityId } from "../entity/selectors";
import { organizationConfigEntityAdapter, organizationConfigSlice } from "./slice";

const selectOrganizationConfigState = (state) => state[organizationConfigSlice.name];

export const selectOrganizationConfigDetailsBySelectedEntityId = createSelector(
  selectOrganizationConfigState,
  selectSelectedEntityId,
  (organizationConfigState, entityId) =>
    organizationConfigEntityAdapter.getSelectors().selectById(organizationConfigState, entityId) || null,
);

export const selectOrganizationConfigDetailsByEntityId = createSelector(
  selectOrganizationConfigState,
  (state, props) => ({
    entityId: props.entityId,
  }),
  (organizationConfigState, { entityId }) =>
    organizationConfigEntityAdapter.getSelectors().selectById(organizationConfigState, entityId) || null,
);

export const selectCustomFields = createSelector(
  selectOrganizationConfigDetailsBySelectedEntityId,
  (organizationConfigDetails) =>
    organizationConfigDetails?.customFields?.filter((bt) => bt?.formType === "clip-tagging") || [],
);

export const selectAllStreamCustomFields = createSelector(
  selectOrganizationConfigDetailsBySelectedEntityId,
  (organizationConfigDetails) =>
    organizationConfigDetails?.customFields?.filter((field) => field?.formType === "stream") || [],
);

export const selectOrganizationConfigPackageDetails = createSelector(
  selectOrganizationConfigDetailsByEntityId,
  (organizationConfigDetails) => organizationConfigDetails?.package_name || [],
);

export const selectOrganizationConfigDetailsIllustoAccountId = createSelector(
  selectOrganizationConfigDetailsByEntityId,
  (organizationConfigDetails) => organizationConfigDetails?.illusto?.accountId || "",
);

export const selectOrganizationConfigAssignedCategories = createSelector(
  selectOrganizationConfigDetailsByEntityId,
  (organizationConfigDetails) => organizationConfigDetails?.categories || [],
);
